import { type WorkflowTrigger } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Button, Sheet, SheetContent } from "@sagot/ui";
import type { WorkflowSettings } from "../types";
import { SettingsCard } from "./settings-card";

interface TriggerSheetProps {
  trigger: WorkflowTrigger;
  settings: WorkflowSettings;
  hasFacing: boolean;
  disabled: boolean;
  onChange: (settings: WorkflowSettings) => void;
  onClose: () => void;
}

/** The trigger's settings in a side sheet: the canvas has no trigger card, so its trigger tile opens this. */
export function TriggerSheet({ trigger, settings, hasFacing, disabled, onChange, onClose }: TriggerSheetProps) {
  const { t } = useTranslation();
  return (
    <Sheet open onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent
        title={t("engage.workflows.builder.trigger")}
        description={t("engage.workflows.canvas.triggerSheetHint")}
        closeLabel={t("common.close")}
        className="max-w-lg"
        footer={<Button onClick={onClose}>{t("engage.workflows.builder.done")}</Button>}
      >
        <SettingsCard trigger={trigger} settings={settings} hasFacing={hasFacing} disabled={disabled} onChange={onChange} />
      </SheetContent>
    </Sheet>
  );
}
